import React from 'react';

const AppStoreDownload = ({ appUrl }) => {
  const appStoreImageUrl = 'https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg';

  return (
    <a
      href={appUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-block',
        overflow: 'hidden',
        borderRadius: '13px',
        width: '250px',
        height: '83px',
      }}
    >
      <img
        src={appStoreImageUrl}
        alt="Download on the App Store"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
    </a>
  );
};

export default AppStoreDownload;